import React from "react";
import { Container, Button, Header } from "semantic-ui-react";
import Sparkle from "react-sparkle";

class AppHeader extends React.Component {
	render() {
		return (
			<Container
				style={{ padding: "20px", position: "relative" }}
				textAlign="center"
			>
				<Header size="huge">Photo Editor</Header>
				<Sparkle color={"purple"} count={100} minSize={10} />
			</Container>
		);
	}
}

export default AppHeader;
